import { ActionPresetDef, DialogueDef, GameDataBundle, HouseDef, NPCDef, QuestDef, VillageDef } from '../types/data';

export class DataRegistry {
  readonly villagesById = new Map<string, VillageDef>();
  readonly housesById = new Map<string, HouseDef>();
  readonly npcsById = new Map<string, NPCDef>();
  readonly dialoguesById = new Map<string, DialogueDef>();
  readonly questsById = new Map<string, QuestDef>();
  readonly actionPresetsById = new Map<string, ActionPresetDef>();
  readonly sourceInfo: string;

  constructor(bundle: GameDataBundle) {
    bundle.villages.forEach((v) => this.villagesById.set(v.id, v));
    bundle.houses.forEach((h) => this.housesById.set(h.id, h));
    bundle.npcs.forEach((n) => this.npcsById.set(n.id, n));
    bundle.dialogues.forEach((d) => this.dialoguesById.set(d.id, d));
    bundle.quests.forEach((quest) => this.questsById.set(quest.id, quest));
    bundle.actionPresets.forEach((preset) => this.actionPresetsById.set(preset.id, preset));
    this.sourceInfo = bundle.sourceInfo ?? 'unknown';
  }

  getVillage(id: string): VillageDef {
    const village = this.villagesById.get(id);
    if (!village) throw new Error(`Village not found: ${id}`);
    return village;
  }

  getAllVillages(): VillageDef[] {
    return [...this.villagesById.values()].sort((a, b) => a.id.localeCompare(b.id));
  }

  getHouse(id: string): HouseDef {
    const house = this.housesById.get(id);
    if (!house) throw new Error(`House not found: ${id}`);
    return house;
  }

  getNPC(id: string): NPCDef {
    const npc = this.npcsById.get(id);
    if (!npc) throw new Error(`NPC not found: ${id}`);
    return npc;
  }

  getDialogue(id: string): DialogueDef {
    const dialogue = this.dialoguesById.get(id);
    if (!dialogue) throw new Error(`Dialogue not found: ${id}`);
    return dialogue;
  }

  getActionPreset(id: string): ActionPresetDef {
    const preset = this.actionPresetsById.get(id);
    if (!preset) throw new Error(`ActionPreset not found: ${id}`);
    return preset;
  }

  getAllQuests(): QuestDef[] {
    return [...this.questsById.values()];
  }
}
